import React, { useRef, useState } from "react";
import { FiUpload } from "react-icons/fi";

let dropzoneInputSeq = 0;

// Upload affordance - opens the native file picker and accepts drag & drop.
export default function Dropzone({
  title,
  hint,
  icon: Icon = FiUpload,
  compact = false,
  onClick,
  className,
  accept,
  onFiles,
}) {
  const inputIdRef = useRef();
  if (!inputIdRef.current) {
    dropzoneInputSeq += 1;
    inputIdRef.current = `rma-nc-dropzone-input-${dropzoneInputSeq}`;
  }
  const inputId = inputIdRef.current;
  const [isDragging, setIsDragging] = useState(false);

  function handleDragOver(event) {
    if (!onFiles) return;
    event.preventDefault();
    setIsDragging(true);
  }

  function handleDragLeave() {
    if (!onFiles) return;
    setIsDragging(false);
  }

  function handleDrop(event) {
    if (!onFiles) return;
    event.preventDefault();
    setIsDragging(false);
    if (event.dataTransfer.files.length > 0) {
      onFiles(Array.from(event.dataTransfer.files));
    }
  }

  const classes = [
    "rma-nc-dropzone",
    compact ? "rma-nc-dropzone--compact" : null,
    isDragging ? "rma-nc-dropzone--dragging" : null,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <label
      htmlFor={onFiles ? inputId : undefined}
      onClick={onClick}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      className={classes}
    >
      {onFiles && (
        <input
          id={inputId}
          type="file"
          multiple
          accept={accept}
          className="sr-only"
          style={{ position: "absolute", width: 1, height: 1, overflow: "hidden", opacity: 0 }}
          onChange={function (event) {
            if (event.target.files && event.target.files.length > 0) {
              onFiles(Array.from(event.target.files));
            }
            event.target.value = "";
          }}
        />
      )}
      <Icon className="rma-nc-dropzone-icon" size={compact ? 22 : 26} strokeWidth={1.8} />
      <span className="rma-nc-dropzone-title">{title}</span>
      <span className="rma-nc-dropzone-hint">{hint}</span>
    </label>
  );
}
